import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface Viaje {
  buque: string | null | number;
  nroViaje: string | null | number;
}

export const getViaje = async (oid: number): Promise<Viaje> => {
  try {
    const res = await apiClient.post<ApiResponse<Viaje>>(
      Endpoints.Depo20ObtenerViaje,
      {
        codViaje: oid,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
